// ============================================================
// SIGMA SMART™ · 150+ DONE-FOR-YOU COACHING SESSIONS & WORKSHEETS™
// All editable values for this landing live in this file.
// ============================================================

// Real Impultienda checkout. ONLY the button inside the offer section goes here.
// utm_* and fbclid from the landing URL are forwarded automatically (lib/checkout.ts).
export const CHECKOUT_URL = 'https://150-done-for-you-coaching-sessions.impultienda.ar/checkout';

// Meta Pixel ID (numbers only). Empty = pixel does nothing.
export const META_PIXEL_ID = '1638213227680390';

// Horizontal bundle WITHOUT background (main product + 4 bonuses), WEBP from Photopea (20%).
// Used in the hero, in the offer AND again in the footer, right before the support email.
// Empty = a coded mockup is shown instead.
export const HERO_BUNDLE_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/2991e31d-039b-470c-b6e7-4bf986e87aeb/1793757945598_cc-11-bundle-sinfondo-cb64e528.webp';

// One WEBP cover per bonus, in order (1 to 4). Empty string = coded cover fallback.
export const BONUS_IMAGES: string[] = [
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/2991e31d-039b-470c-b6e7-4bf986e87aeb/1793757921127_cc-03-bono1-questions-6ef28f2b.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/2991e31d-039b-470c-b6e7-4bf986e87aeb/1793757927323_cc-04-bono2-intake-f67f9600.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/2991e31d-039b-470c-b6e7-4bf986e87aeb/1793757932328_cc-05-bono3-workshop-4b6ac69c.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/2991e31d-039b-470c-b6e7-4bf986e87aeb/1793757939550_cc-06-bono4-planner-3644072c.webp',
];

export const PRICE = 27;
export const ORIGINAL_PRICE = 54;
export const CURRENCY = 'USD';

export const SEO = {
  title: '150+ Done-For-You Coaching Sessions & Worksheets™ | SIGMA SMART™',
  description:
    '78 ready-to-run coaching sessions and 78 matching client worksheets in 6 volumes: goals, mindset, stress, habits, boundaries, leadership and career. For 1:1, groups and online. Instant PDF access + 4 bonuses.',
};

export const SUPPORT_EMAIL = 'soporte.sigmasmart@gmail.com';
export const INSTAGRAM_HANDLE = '@sigmasmart.en';
export const INSTAGRAM_URL = 'https://instagram.com/sigmasmart.en';
